import { render, staticRenderFns } from "./PersonList.vue?vue&type=template&id=bc75a046&scoped=true"
import script from "./PersonList.vue?vue&type=script&lang=js"
export * from "./PersonList.vue?vue&type=script&lang=js"
import style0 from "./PersonList.vue?vue&type=style&index=0&id=bc75a046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc75a046",
  null
  
)

export default component.exports